module.exports = __webpack_public_path__ + "img/cloudy.aa3e250.svg";